'use strict';

var log = require('../../log/Log').channel('ThemeController');
require('./ThemeService');

angular.module('inara').controller('ThemeController', ThemeController);

ThemeController.$inject = ['$scope', 'ThemeService'];

function ThemeController($scope, ThemeService) {
    var vm = this;
    log.info('initializing');

    vm.getThemeStyle = ThemeService.getThemeStyle;
}

module.exports = ThemeController;
